import SettingBase from '../settings/util/SettingBase'
import AppConstants from '../../config/app.constants';

class RouteStatsController {
    /*@ngInject*/
    constructor(Auth, $scope, $state, User, Modal, $uibModal, $translate, SetupService, RouteService, RouteStatsService, 
                      $q, DateUtil, RouteProgressService, VaultOperationsService, $rootScope, DataCounter, Navigation,
                      CommonLayoutService, UserBranchService) {
        this.$state = $state;
        this.User = User;
        this.Modal = Modal;
        this.$translate = $translate;
        this.SetupService = SetupService;
        this.RouteService = RouteService;
        this.RouteStatsService = RouteStatsService;
        this.$q = $q;
        this.DateUtil = DateUtil;
        this.RouteProgressService = RouteProgressService;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.DataCounter = DataCounter;
        this.Navigation = Navigation;
        this.VaultOperationsService = VaultOperationsService;
        this.CommonLayoutService = CommonLayoutService;
        this.UserBranchService = UserBranchService;

        this.model = {
            vaultDate: null,
            allRoutes: [],
            totalRoutes: 0,
            branch: this.User.getUser().branchId,
            selectedRoute: {},
            route: null,
            routeStops: [],
            infoWindowLoading: false,
            loadingMap: false,
            shipmentServiceTickets: [],
            selectedBranch: '',
            branchObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                searchText: null,
            },
            routeListObj: {
                loading: false,
                results: [],
                totalRecords: 0
            },
            loggedInUser: User.getUser().id,
            isExporting: false,
        };

        this.colorMapping = {
            DO: 'green',
            CANT: 'red',
            PENDING: 'orange',
            PARTIAL: 'orange',
            NO_PICKUP: 'red',
            DELIVERED_NO_PICKUP: 'red'
        }

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        }
        this.showShipmentSidebar = false;
        this.markerPosition = [];
        this.isInitialized = true;
        this.routeDataObj = {};
        this.branchInfo = null;
        this.$rootScope.$broadcast('routeChange', '/app/route-stats');
    }

    loadImage(image) {
        this.icon = {
            'REGULAR': 'regular.png',
            'ATM': 'atm.png',
            'BANK': 'bank.png',
            'NO_SHIP_NO_GO': 'nsng.png',
            'INTERNAL': 'internal.png',
            'TRUCK': 'truck.png',
            'TANKER': 'tanker.png',
            'WINDOW': 'window.png',
            'CARRIER': 'carrier.png',
            'ON_CALL': 'oncall.png',
            'LOCKER': 'locker.png',
            'VAULT': 'vault.png',
            'DELIVERY': 'delivery.png'
        }

        let imgURL = this.icon[image]
        return require('../../assets/images/' + imgURL);
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.UserBranchService.getUserBranches(this.model.loggedInUser)
            //this.getRouteList()
        ])
            .then((data) => {
                setTimeout(() => {
                    this.branchInfo = data[0];
                    const date = this.DateUtil.convertToDate(data[0].currentVaultDate);
                    this.vaultDate = moment(date).format('YYYY-MM-DD');

                    this.model.branchObj.results = data[1].results;
                    this.model.branchObj.results.forEach((branch) => {
                        if (branch.branchId == this.model.branch) {
                            branch.ticked = true;
                        }
                    })
                    this.getRouteList();
                    this.filterRouteList();
                    this.loadMap()
                    this.$scope.$apply();
                })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    loadMap() {
        this.routePosition = 0;
        this.centerLattitude = this.lat / this.totalLatLongLocations || 28.635308;
        this.centerLongitude = this.long / this.totalLatLongLocations || 77.70641;

        if (this.isInitialized) {
            this.map = L.map('map', {
                center: [this.centerLattitude, this.centerLongitude],
                zoom: 11
            });

            // this.map.fitBounds(this.locationLatLong.length ? this.locationLatLong : [[this.branchInfo.gpsLat, this.branchInfo.gpsLong]]);
            if (this.locationLatLong && this.locationLatLong.length) {
                this.map.fitBounds(this.locationLatLong);
            }

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(this.map);
        }
        this.manageMarkers()
        // this.drawRoute()
    }

    drawRoute() {
        var pointA = new L.LatLng(28.635308, 77.22496);
        var pointB = new L.LatLng(28.984461, 77.70641);
        var pointList = [pointA, pointB];

        var firstpolyline = new L.Routing(pointList, {
            color: 'black',
            weight: 3,
            opacity: 0.5,
            smoothFactor: 1
        });
        firstpolyline.addTo(this.map);
    }

    manageMarkers() {
        if (this.markerPosition && this.markerPosition.length) {
            this.markerPosition.forEach((marker) => {
                this.map.removeLayer(marker);
            })
        }

        this.model.routeStops.forEach((sequenceData, index) => {
            if (sequenceData && sequenceData.lat && sequenceData.long) {
                // this.routePosition = _.findIndex(routeSequenceData, { locationId: sequenceData.locationId }) + 1;
                this.markerColor = sequenceData.stopStatus ? this.colorMapping[sequenceData.stopStatus] : 'blue'
                this.actualLat = sequenceData.lat;
                this.actualLong = sequenceData.long;

                this.locationInfo = '<strong>' + _.cloneDeep(sequenceData.routeSeq) + '</strong> | ' + 
                    '<strong>' + sequenceData.name + '</strong>' + '<br>' + sequenceData.address + ' - ' + sequenceData.zip +
                    '<br>' + sequenceData.city + ', ' + sequenceData.state;
                if (sequenceData.completedTime) this.locationInfo = this.locationInfo.concat(', ', '<br>', '<strong>', moment(sequenceData.completedTime).format('YYYY-MM-DD hh:mm a'), '</strong>');
                const id = L.marker([this.actualLat, this.actualLong],
                    {
                        icon: new L.AwesomeNumberMarkers({
                            // number: index + 1,
                            number: sequenceData.routeSeq = sequenceData._index, //=== -1 ? 'ST' : sequenceData.routeSeq,
                            markerColor: this.markerColor
                        })
                    })
                    .addTo(this.map)
                    .bindPopup(this.locationInfo)

                id.on('mouseover', function () {
                    id.openPopup();
                });

                id.on('mouseout', function () {
                    id.closePopup();
                });
                id.on('click', () => {
                    if (this.model.infoWindowLoading) return;
                    this.openNav()
                    this.model.infoWindowLoading = true;
                    this.model.selectedLocation = sequenceData;
                    this.showShipmentSidebar = true;
                    this.getRouteShipmentDetail();
                    // setTimeout(() => {
                    //     this.model.infoWindowLoading = false;
                    //     this.$scope.$apply()
                    // }, 1500)
                })

                this.markerPosition.push(id);
            }
        })
        if (this.map && this.model.coordinates && this.model.coordinates.length) {
            const waypoints = this.model.coordinates.map(c => L.latLng(c.latlng));
            L.polyline(waypoints, { color: "#40826D" }).addTo(this.map);

            function createArrowIcon(degree) {
                return L.divIcon({
                    className: 'custom-icon',
                    html: '<div style="transform: rotate(' + degree + 'deg);"><img src="../../assets/images/direction.png" class="direction-icon" /></div>',
                    iconSize: [22, 22],
                    iconAnchor: [11, 11],
                });
            }
            this.model.coordinates.forEach(point => {
                if (!point.direction || point.direction == -1) return;
                const latLng = point.latlng;
                const arrowMarker = L.marker(latLng, { icon: createArrowIcon(point.direction) });
                arrowMarker.addTo(this.map);
            });
        }
    }
    onLocationSelect(shipmentLoc) {
        if (this.model.infoWindowLoading) return;
        this.openNav()
        this.model.infoWindowLoading = true;
        this.model.selectedLocation = shipmentLoc;
        this.showShipmentSidebar = true;
        this.getRouteShipmentDetail();
    }
    infoWindowToggle(route) {
        this.getRouteStops(route)
    }

    getRouteList() {
        setTimeout(() => {
            const startDate = moment(this.vaultDate).format('YYYY-MM-DD');
            const endDate = moment(this.vaultDate).format('YYYY-MM-DD')
            const branches = this.getSelectedBranches();
            const routeId = this.model.routeId ? this.model.routeId.Value : null;

            this.gettingRoutes = true;
            this.VaultOperationsService.getRouteList('', startDate, endDate, 0, 1000,
                'routeDate', 'DESC', moment.tz.guess(), null, branches, routeId)
                .then((data) => {
                    this.model.allRoutes = data.results;
                    this.model.totalRecords = data.totalRecords;

                    this.showShipmentSidebar = false;
                    this.model.selectedRoute = null;
                    if (this.map) {
                        this.map.eachLayer((layer) => {
                            if (layer instanceof L.Polyline || layer instanceof L.Marker) {
                                this.map.removeLayer(layer);
                            }
                        });
                    }
                    
                    this.markerPosition = [];
                    this.model.routeStops = [];
                    this.model.coordinates = [];
                    this.locationLatLong = [];
                    this.lat = 0;
                    this.long = 0;
                    this.totalLatLongLocations = 0;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.gettingRoutes = false;
                })
        })
    }

    removeMapMarkers() {
        this.map.remove();
        this.isInitialized = true;
        this.markerPosition.forEach((id) => {
            this.map.removeLayer(id)
        });
        this.markerPosition = [];
    }

    resetSorting() {
        this.model.sortColumn = '_index';
        this.model.reverseSort = false;
    }

    getRouteStops(route) {
        if (route) {
            // if (!this.model.selectedRoute || this.model.selectedRoute.routeId == route.routeId) return
            // this.model.selectedRoute = route;
            if(this.model.selectedRoute && this.model.selectedRoute.routeId === route.routeId) {
                    this.model.selectedRoute = null;
                    this.showShipmentSidebar = false;
                if (this.map) {
                    this.map.remove();
                    this.isInitialized = true;
                    this.markerPosition.forEach((id) => {
                        this.map.removeLayer(id)
                    });
                    this.markerPosition = [];
                    this.model.routeStops = [];
                    setTimeout(()=>{
                        this.loadMap();
                        this.map.invalidateSize()
                        if (this.locationLatLong && this.locationLatLong.length) {
                            this.map.fitBounds(this.locationLatLong);
                        }
                    },100)
                }
            }
            else {
                this.model.selectedRoute = route;
                if (this.model.loadingMap) return;
                route.isLoading = true;
                route.isExpand = true;
                this.model.loadingMap = true;
                const formattedDate = this.DateUtil.getUTCDate(route.routeDate);
                this.model.loading = true;
                this.routePosition = 0;
                this.lat = 0;
                this.long = 0;
                this.totalLatLongLocations = 0;
                this.stopsInfo = "";
                this.locationLatLong = [];
                this.closeNav();
                this.RouteProgressService.getRouteStops(route.routeId, formattedDate, route.branchId)
                    .then((data) => {
                        this.model.loadingMap = false;
                        route.isLoading = false;
                        let routeProgressData = _.orderBy(data.results, ['completedTime'], ['asc']);
                        this.model.routeStops = data.results;
                        this.model.routeDetails = data.routeDetails;
                        route.shipmentLocations = this.model.routeStops;
                        this.model.coordinates = data.coordinates;

                        this.model.routeStops.forEach((j) => {
                            routeProgressData.forEach((k, index) => {
                                if ((j.completedTime && k.completedTime) && (j.locationId == k.locationId)) {
                                    j.stopProcessOrder = index + 1;
                                }
                            })
                        })

                        this.stopsInfo = data;
                        if (this.model.routeStops.length) {
                            this.model.routeStops.forEach((data, index) => {
                                if (data.lat && data.long) {
                                    this.locationLatLong.push(new Array(data.lat, data.long));
                                    this.totalLatLongLocations += 1;
                                    this.lat += data.lat;
                                    this.long += data.long;
                                }
                            })
                        }
                        this.resetSorting();
                    })
                    .then(() => {
                        if (this.map) {
                            this.removeMapMarkers()
                        }
                        // if (this.map && this.model.routeStops.length) { this.removeMapMarkers() }

                        setTimeout(() => {
                            // if (this.model.routeStops.length) {
                            this.loadMap();
                            this.addBranchDetails();
                            // }
                        }, 100);

                    })
                    .catch((err) => {
                        console.log(err);
                        if (err && err.data && err.data.message) {
                            return this.Modal.errorModal(err.data.message)
                        }
                        this.model.loadingMap = false;
                        route.isLoading = false;
                    })
                    .finally(() => {

                    })
            }
        } else {
            this.map.remove();
            this.isInitialized = true;
            this.markerPosition.forEach((id) => {
                this.map.removeLayer(id)
            });
            this.markerPosition = [];
            this.model.routeStops = [];
            this.closeNav();
            setTimeout(() => {
                this.loadMap();
            }, 100);
        }
        // route.isExpand = !route.isExpand;
    }

    getRouteShipmentDetail() {
        // console.log(this.model.selectedRoute, this.model.selectedLocation)
        // let locationId = 'RF0217AS1', //this.model.selectedLocation.locationId,
        // routeId = 'BAL-001', //this.model.selectedLocation.routeId,
        // vaultDate = '2021-12-22'; //this.DateUtil.getUTCDate(this.model.selectedLocation.routeDate);

        let locationId = this.model.selectedLocation.locationId,
            routeId = this.model.selectedLocation.routeId,
            vaultDate = this.DateUtil.getUTCDate(this.model.selectedLocation.routeDate);

        this.model.infoWindowLoading = true;
        this.RouteStatsService.getRouteShipmentDetail(vaultDate, routeId, locationId, this.model.routeDetails.messengerId)
            .then((res) => {
                this.model.shipmentDetails = res.result;
                this.model.shipmentServiceTickets = res.serviceTickets;
                this.model.locationActivity = res.locationActivity;
            })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                this.model.infoWindowLoading = false;
            })
    }

    showShipmentReceipt(dataObj, stats) {
        let shipmentObj = {};

        dataObj.forEach((details) => {
            Object.assign(shipmentObj, new Object({ [details.key]: details.value }))
        })

        // document.getElementById('shipment-image').blur();
        this.Modal.shipmentImageModal(shipmentObj, shipmentObj.trackingId, stats, ({ modal }) => {
        }, ({ modal }) => {
            modal.close();
        });
    }

    openNav() {
        document.getElementById("locationShipmentInfo").style.width = '25%'//this.getScreenWidth();
        // document.getElementById("map").style.marginRight = '23%' //this.getScreenWidth();
        if (this.map) {
            setTimeout(() => {
                this.map.invalidateSize()
                if (this.locationLatLong && this.locationLatLong.length) {
                    this.map.fitBounds(this.locationLatLong);
                }
            }, 500)
        }
    }
    closeNav() {
        document.getElementById("locationShipmentInfo").style.width = "0px";
        document.getElementById("map").style.marginRight = "0px";
        this.showShipmentSidebar = false;
        if (this.map) {
            setTimeout(() => {
                this.map.invalidateSize()
                if (this.locationLatLong && this.locationLatLong.length) {
                    this.map.fitBounds(this.locationLatLong);
                }
                this.markerPosition = [];
                this.model.routeStops = [];
                this.model.coordinates = [];
                this.locationLatLong = [];
                this.lat = 0;
                this.long = 0;
                this.totalLatLongLocations = 0;
            }, 500)
        }
    }

    translateTransactionType(transactionType, shipment) {
        if (!transactionType) return this.$translate.instant('common.n_a');
        if (transactionType.includes('shipment.')) {
            return this.$translate.instant(`${transactionType}`);
        } else {
            return this.$translate.instant(`shipment.${transactionType}`).toUpperCase();
        }
    }

    goToUserTab(userId) {
        if (!userId) return;
        this.Navigation.goToUserTab(userId, null);
    }

    addBranchDetails() {
        if (!this.branchInfo || !this.branchInfo.gpsLat || !this.branchInfo.gpsLong) return;
        
        let locationInfo = '<strong>' + this.branchInfo.branchId + '</strong>' + '<br>' + this.branchInfo.address + ' - ' + this.branchInfo.zip +
            '<br>' + this.branchInfo.city + ', ' + this.branchInfo.state;

        const id = L.marker([this.branchInfo.gpsLat, this.branchInfo.gpsLong],
            {
                icon: new L.AwesomeNumberMarkers({
                    number: 'B',
                    markerColor: 'black'
                })
            })
            .addTo(this.map)
            .bindPopup(locationInfo)

        id.on('mouseover', function () {
            id.openPopup();
        });

        id.on('mouseout', function () {
            id.closePopup();
        });
    }

    getStopStatus(data) {
        if ((data && !data.stopStatus && !data.completedTime) || (data.stopStatus === 'PENDING')) return this.$translate.instant('routeProgress.pending');
        else if (data.completedTime && data.stopStatus === 'PARTIAL') return this.$translate.instant('routeProgress.partial');
        else if (data && data.stopStatus === 'DO') return this.$translate.instant('routeProgress.delivered');
        else if (data && data.stopStatus === 'CANT' && (data.totalTransactionRecords > 0 || data.totalTransactionRecords === 0)) return this.$translate.instant('routeProgress.cant').toUpperCase();
        else if (data.completedTime && data.stopStatus === 'NO_PICKUP') return this.$translate.instant('routeProgress.no_pickup');
        else if (data.completedTime && data.stopStatus === 'DELIVERED_NO_PICKUP') return this.$translate.instant('routeProgress.delivered_no_pickup');
        else return;
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    resetData() {
        setTimeout(()=>{
            this.model.routeId = null;
            // this.model.selectedBranch = null;
            this.showShipmentSidebar = false;
            if (this.map) {
                this.map.remove();
                this.isInitialized = true;
                this.markerPosition.forEach((id) => {
                    this.map.removeLayer(id)
                });
                this.markerPosition = [];
                this.model.routeStops = [];
                setTimeout(()=>{
                    this.loadMap();
                    this.map.invalidateSize()
                    if (this.locationLatLong && this.locationLatLong.length) {
                        this.map.fitBounds(this.locationLatLong);
                    }
                    this.model.selectedRoute = null;
                },100)
            }
            this.$scope.$apply();
        })
    }

    filterRouteList(searchKey,offset) {
        setTimeout(() => {
            const startDate = moment(this.vaultDate).format('YYYY-MM-DD');
            const endDate = moment(this.vaultDate).format('YYYY-MM-DD');
            const branches = this.getSelectedBranches();
		    searchKey = searchKey || null;

            this.VaultOperationsService.getFilterRouteList(startDate, endDate, branches, null, searchKey, AppConstants.defaultPageLimit, offset)
                .then((data) => {
                    if (offset === 0 || offset == undefined) {
                        this.model.routeListObj.totalRecords = data.totalRecords;
                        this.model.routeListObj.results = this.mapData(data.data);
                    }
                    else {
                        const routes = this.mapData(data.data);
                        this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.gettingRoutes = false;
                })
              
        })
    }

    mapData(routes) {
        return routes.map((route) => {
            return {
                Key: route.routeId,
                Value: route.routeId
            }
        })
    }

    exportData(route) {
        const formattedDate = this.DateUtil.getUTCDate(route.routeDate);
        var reportPrefix = 'Route Stop';

        this.model.isExporting = true;
        this.RouteProgressService.exportRouteStops(route.routeId, formattedDate, route.branchId)
            .then((data) => {
                this.fileName = reportPrefix.concat('_', route.branchId, '_', (route.routeId), '.csv');
                let a = document.createElement("a");
                document.body.appendChild(a);
                let file = new Blob([data.csvString], { type: 'application/csv' });
                let fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = this.fileName;
                a.click();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message)
                }
            })
            .finally(() => {
                this.model.isExporting = false;
            })
    }

    showReceipt(shipment, stats) {
        document.getElementById('shipment-image').blur();
        this.Modal.shipmentImageModal(shipment, shipment.trackingId, stats, ({ modal }) => {
        }, ({ modal }) => {
          modal.close();
        });
      }
}

export default RouteStatsController;



// WEBPACK FOOTER //
// ./client/app/components/route_stats/route_stats.controller.js